"use strict";

var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

exports.__esModule = true;
exports.wrapRootElement = void 0;

var _react = _interopRequireWildcard(require("react"));

var _react2 = require("@builder.io/partytown/react");

var _gatsbyScript = require("gatsby-script");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function PartytownProvider(_ref) {
  var children = _ref.children;

  var _ref2 = (0, _react.useState)({
    collectedForwards: new Set(),
    collectedAnyScript: false
  }),
      _ref3 = _slicedToArray(_ref2, 2),
      _ref3$ = _ref3[0],
      collectedForwards = _ref3$.collectedForwards,
      collectedAnyScript = _ref3$.collectedAnyScript,
      setState = _ref3[1];

  return /*#__PURE__*/_react.default.createElement(_gatsbyScript.PartytownContext.Provider, {
    value: {
      collectScript: function collectScript(newScript) {
        var stateShouldChange = false;
        var potentialNewState = {
          collectedAnyScript: collectedAnyScript,
          collectedForwards: collectedForwards
        };

        if (!collectedAnyScript) {
          potentialNewState.collectedAnyScript = true;
          stateShouldChange = true;
        }

        if (newScript !== null && newScript !== void 0 && newScript.forward) {
          if (Array.isArray(newScript.forward)) {
            var _iterator = _createForOfIteratorHelper(newScript.forward),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var singleForward = _step.value;

                if (!potentialNewState.collectedForwards.has(singleForward)) {
                  potentialNewState.collectedForwards.add(singleForward);
                  stateShouldChange = true;
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          } else {
            if (process.env.NODE_ENV === "development") {
              console.log("unexpected shape of forward", newScript);
            }
          }
        }

        if (stateShouldChange) {
          setState(potentialNewState);
        }
      }
    }
  }, children, collectedAnyScript && /*#__PURE__*/_react.default.createElement(_react2.Partytown, {
    key: "partytown",
    forward: Array.from(collectedForwards)
  }));
}

var wrapRootElement = function wrapRootElement(_ref4) {
  var element = _ref4.element;
  return /*#__PURE__*/_react.default.createElement(PartytownProvider, null, element);
};

exports.wrapRootElement = wrapRootElement;